import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ComicsPage from "../pages/comics/page";
import ComicDetailPage from "../pages/comic/detail";
import ReadPage from "../pages/comic/read";
import SearchPage from "../pages/search/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/comics",
    element: <ComicsPage />,
  },
  {
    path: "/comic/:id",
    element: <ComicDetailPage />,
  },
  {
    path: "/comic/:id/read",
    element: <ReadPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;